export function courseUrl() {
  // 课程
  const httpUrl = [
    '/theUserIdentity/refund/detail',
    '/theUserIdentity/refund/courseOrderTally',
    '/sign/setSignTallyStatus',
    '/theUserIdentity/classPartition/pageExport',
    '/theUserIdentity/classroomStudentRec/classroomStudentRecExport',
    '/theUserIdentity/classroomStudentRec/classroomStudentRecDetail',
    '/theUserIdentity/classroomStudentRec/classroomStudentRecPage',
    '/theUserIdentity/courseClass/listSignAndTallyByOrderId',
    '/sign/countByProductIdStudentId',
    '/theUserIdentity/classStudent/studentConvertDiffClass',
    '/theUserIdentity/classStudent/studentBindDiffClass',
    '/theUserIdentity/classStudent/convertDiffClassStuPage',
    '/school/courseTypeDefine/courseTypeListByOffer',
    '/theUserIdentity/courseClassDetail/getCourseClassDirection',
    '/theUserIdentity/courseClassDetail/CourseClassDirectionExport',
    '/theUserIdentity/courseClassDetail/getCourseClassDirectionDetail',
    '/theUserIdentity/courseClass/closeCourseClass/msg',
    '/theUserIdentity/classPartition/exportExcel',
    '/theUserIdentity/courseClass/serachCourseDefine',
    '/theUserIdentity/dataSearch/searchTeachers',
    '/schoolOrgRel/pageOrgSchoolName',
    '/theUserIdentity/courseDefine/getCourseProviderList',
    '/theUserIdentity/courseDefine/putCourse',
    '/theUserIdentity/courseDefine/deleteCourse',
    '/theUserIdentity/courseDefine/getCoursePutAwayPage',
    '/theUserIdentity/courseClass/exportByCondition',
    '/theUserIdentity/courseClass/delete',
    '/theUserIdentity/courseClass/getCourseClassDtl',
    '/theUserIdentity/courseClass/serachProvider',
    '/courseClass/listCourseOrder',
    '/theUserIdentity/courseClass/batchUpdate',
    '/theUserIdentity/courseDefine/getCoursePage',
    '/theUserIdentity/courseDefine/uploadCourse',
    '/theUserIdentity/courseDefine/getSchoolList',
    '/theUserIdentity/courseClass/update',
    '/theUserIdentity/courseClass',
    '/theUserIdentity/courseClass/listByCondition',
    '/theUserIdentity/courseTypeDefine/courseTypeDefinePage',
    '/theUserIdentity/courseClass/getRelSchool',
    '/courseClass/classSet',
    '/courseType/courseTypeList',
    '/course/stat/stuEnroll',
    '/sign/sch',
    '/courseType/courseType',
    '/courseType',
    '/courseDefine/publish',
    '/courseDefine',
    '/courseDefine/orgPage',
    '/courseDefine/check',
    '/courseClass',
    '/courseClass/orgClassPage',
    '/courseDefine/schoolIntroPage',
    '/courseType/courseTypes',
    '/courseDefine/schoolPage',
    '/courseDefine/schoolCheckPage',
    '/courseDefine/selectSchoolPage',
    '/courseDefine/schoolCheckCourseList',
    '/courseClassPeriod/list',
    '/courseClass/checkCourseState',
    '/courseClassPeriod/list',
    '/sign/sch/sign',
    '/leave/sch',
    '/sign/sch/nosign',
    '/sign/sch/tea',
    '/theUserIdentity/sign/sch/tea',
    '/theUserIdentity/classPartition/listOfWaitPartition',
    '/courseClass/eduClassPage',
    '/course/stat/classEnroll',
    '/course/stat/classNoEnroll',
    '/courseClass/timetable',
    '/courseClass/class/enroll',
    '/courseClass/deleteTimetable',
    '/courseClass/modifyTimetable',
    '/course/mien/detail',
    '/course/enroll/student',
    '/course/classroom/student',
    '/course/classroom/schedule',
    '/course/classroom/apprise',
    '/courseClassDetails/details',
    '/course/classroom/endApprise',
    '/course/stop/student',
    '/course/stat/stuEnroll',
    '/course/stuEnroll',
    '/course/week/course',
    '/courseClass/org/class/enroll',
    '/course/org/mien/detail',
    '/courseClass/schoolClassPage',
    '/courseClass/classroomState',
    '/classroomStudents/classroomStudent/org/school',
    '/courseClass/creatTimetables',
    '/courseClassPeriod',
    '/courseClass/saveClassPeriod',
    '/courseClass/addTimetable',
    '/courseClass/classroomState',
    '/sign/export/tea',
    '/sign/remind/stu',
    '/sign/remind/tea',
    '/sign/sch/export',
    '/course/stat/stuEnroll/export',
    '/course/export/schoolIntro',
    '/course/export/school',
    '/course/export/schoolCheck',
    '/course/enroll/student/export',
    '/courseClass/class/leave/detail',
    '/courseClass/listUnPubBySchool',
    '/courseClass/org/class/sign/total',
    '/courseClass/class/sign/total',
    '/courseClass/classSet',
    '/theUserIdentity/classPartition/create',
    '/theUserIdentity/classPartition/page',
    '/theUserIdentity/classPartition/detail',
    '/theUserIdentity/classStudent/classroomStudents',
    '/theUserIdentity/classTeacher/teachers',
    '/theUserIdentity/classPartition/updateClassInfo',
    '/theUserIdentity/classStudent/dispatchStudent',
    '/theUserIdentity/classStudent/studentLeaveClass',
    '/theUserIdentity/classStudent/updateClassRemark',
    '/theUserIdentity/classStudent/studentConvertClass',
    '/theUserIdentity/classStudent/studentConvertDiffClassInClass',
    '/theUserIdentity/classTeacher/add',
    '/theUserIdentity/classTeacher/suspend',
    '/theUserIdentity/classPartition/updateCourseScheduleRule',
    '/theUserIdentity/classTeacher/replace',
    '/theUserIdentity/classPartition/updateTeacherSignRule',
    '/theUserIdentity/classroomSign/findStudentSignsOfMonth',
    '/theUserIdentity/classStudent/unPartitionPage',
    '/theUserIdentity/classStudent/pageByStu',
    '/theUserIdentity/classroomSign/batchSetToSigned',
    '/theUserIdentity/leave/batchSaveLeave',
    '/theUserIdentity/classroomSign/batchSetToLeave',
    '/theUserIdentity/classroomSign/batchSetToNoChecking',
    '/theUserIdentity/courseClassDetail/timetableOfTeachers',
    '/theUserIdentity/courseClassDetail/timetableOfSchool',
    '/theUserIdentity/courseClassDetail/timetableOfStudents',
    '/theUserIdentity/courseClassDetail/timetableOfPerson',
    '/theUserIdentity/courseClassDetail/timetableOfClassroom',
    '/theUserIdentity/courseClassDetail/pageOfSign',
    '/theUserIdentity/courseClassDetail/update',
    '/theUserIdentity/classStudent/productStudents',
    '/theUserIdentity/courseTypeDefine/courseTypeDefinePage',
    '/theUserIdentity/courseTypeDefine/getTapList',
    '/theUserIdentity/courseTypeDefine/addCourseTypeDefine',
    '/theUserIdentity/courseTypeDefine/updateCourseTypeDefine',
    '/theUserIdentity/courseTypeDefine/deleteCourseTypeDefine',
    '/theUserIdentity/courseTypeDefine/getCourseTypeTapList',
    '/theUserIdentity/courseDefine/getYearTerm',
    '/theUserIdentity/courseDefine/getRelEdu',
    '/getFileInfo',
    '/theUserIdentity/courseTypeDefine/serachIsExsitEduCourseTypeDefine',
    '/theUserIdentity/courseSchedule/getCourseSchedule',
    // '/admin/courseSchedule/getCourseSchedule',
    '/theUserIdentity/courseSchedule/updateStatus',
    '/theUserIdentity/courseSchedule/conflictOrgList',
    // '/admin/courseSchedule/conflictOrgList', // 暂时教育局端也用admin
    '/theUserIdentity/courseSchedule/update',
    '/theUserIdentity/classPartition/smartPartitionPreview',
    '/theUserIdentity/classPartition/smartPartition',
    '/theUserIdentity/dataStatistics/workTableOverView',
    '/theUserIdentity/courseClassDetail/getTaskId',
    '/theUserIdentity/leave/listLeaveByCondition', // 学生请假列表 v2.1.5
    '/theUserIdentity/leave/updateRefund', // 学生请假列表-设置退款 v2.1.5
    '/theUserIdentity/leave/agreeLeaveAudit', // 学生请假列表-同意请假审批 v2.1.5
    '/theUserIdentity/leave/rejectLeaveAudit', // 学生请假列表-驳回请假审批 v2.1.5
    '/theUserIdentity/leave/getLeaveDetail', // 学生请假详情 v2.1.5
    '/theUserIdentity/leave/exportByCondition', // 学生请假导出excel
    '/theUserIdentity/classroomStudentLeave/getSseId', // 学生请假单导入,获取任务id v2.1.6
    '/theUserIdentity/classroomStudentLeave/batchLeaveStudentImport', // 学生请假单导入 v2.1.6
    '/theUserIdentity/classroomStudentLeave/batchSaveLeaveStudent', // 批量保存请假请假导入数据 v2.1.6
    '/theUserIdentity/courseClass/deleteCourseClass', //  删除课程班级 v2.1.6
    '/theUserIdentity/classPartition/classroomSignExport', // 分班管理-导出班级考勤 v2.1.9
    '/theUserIdentity/sign/sch/studentSign', // 学生考勤-学生考勤（pc）v2.1.9
    '/theUserIdentity/sign/sch/studentSignInfo', // 学生考勤-学生考勤明细（pc）v2.1.9
    '/theUserIdentity/sign/export/student', // 学生考勤-导出学生考勤（pc）v2.1.9
    '/theUserIdentity/sign/export/studentInfo', // 学生考勤-导出学生考勤明细（pc）v2.1.9
    '/theUserIdentity/sign/getSseId', // 学生考勤-导出学生考勤明细-获取任务id（pc）v2.1.9
    '/theUserIdentity/sign/exportStudentTask', // 学生考勤-导出学生考勤明细-导出（pc）v2.1.9
    '/theUserIdentity/courseClass/downloadTemplate',
    '/school/courseClass/downloadTemplate',
    '/org/courseClass/downloadTemplate',
    '/theUserIdentity/courseClass/importCourseClass',
    '/school/courseClass/importCourseClass',
    '/org/courseClass/importCourseClass',
    '/dataSearch/getYearList',
    // '/theUserIdentity/sysStaticData/getOtherSetting', //  // 课程设置 - 其他设置
    // '/theUserIdentity/sysStaticData/saveSysStaticData',
    '/theUserIdentity/classPartition/smartPartitionPreviewMore', // 排课中心-分班管理-智能分班-多商品分班预览
    '/theUserIdentity/classPartition/smartPartitionMore', // 排课中心-分班管理-智能分班-多商品分班提交接口
    '/dataSearch/searchTerm',
    '/theUserIdentity/dataSearch/searchClassroomDetail',
    '/school/dataSearch/searchClassroomDetail',
    '/theUserIdentity/classStudent/studentBindClassroom', // 学生入班 -- 新 2022-06-02
    '/theUserIdentity/classTeacher/getDetailWithTeaSign',
    '/theUserIdentity/classTeacher/alterTeacherSignInClass', // 新增任课教师 -- 新 2023-11-08
    '/theUserIdentity/classStudent/studentUnBindClassroom',
    '/theUserIdentity/classroomStudentAct/actHistoryPage',

    '/theUserIdentity/courseClassDetail/listSchStuSignClassNo', // 学生考勤-明细-查询未上课节次 v2.1.11
    '/theUserIdentity/sign/updateStuAttendanceStatus', // 学生考勤-明细-更新考勤状态（pc） v2.1.11
    '/theUserIdentity/sign/signActQueryByPage', // 学生考勤-明细-查询操作记录（pc）v2.1.11
    '/theUserIdentity/sign/addStuAttendanceStatus', // 学生考勤-明细-新增考勤状态（pc）2022.06.10解耦需求
    '/theUserIdentity/classPartition/convertDiffPage', // 同价格跨商品课班分页2022.06.10解耦需求
    '/theUserIdentity/classStudent/studentConvertBindClassroom', // 学生转班 2022.06.10解耦需求
    '/theUserIdentity/classStudent/studentConvertBindDiffClass', // 跨商品学生转班 2022.06.10解耦需求
    '/theUserIdentity/leave/cancelLeaveAudit', // 撤销请假 2022.06.10解耦需求

    '/theUserIdentity/courseClassDetail/batchUpdateDetailDate',
    '/theUserIdentity/courseClassCombos/subProductPage',
    '/school/courseClassCombos/subProductPage',
    '/theUserIdentity/courseClassCombos/saveProductPackage',
    '/theUserIdentity/courseClassCombos/productPackagePage',
    '/school/courseClassCombos/productPackagePage',
    '/theUserIdentity/courseClassCombos/productPackageDetail',
    '/theUserIdentity/courseClassCombos/updateProductPackage',
    '/school/courseClassCombos/updateProductPackage',
    '/theUserIdentity/courseClassCombos/deleteProductPackage',
    '/school/courseClassCombos/deleteProductPackage',
    '/theUserIdentity/dataSearch/searchSchool',
    '/theUserIdentity/courseClassDetail/batchUpdateDetailDate',
    '/school/courseClassCombos/saveProductPackage',
    '/theUserIdentity/refund/order/detail', // 订单列表页面-退款申请的展示 2022.07.14（新版退款）

    '/theUserIdentity/leave/deleteLeave',
    '/theUserIdentity/divideConfigMainItems/listByTypeAndOrgIdAndSchId',
    '/theUserIdentity/courseClass/getListByDivideRuleId',
    '/theUserIdentity/divideConfigMainItems/listByCondition',
    '/theUserIdentity/academicStaff/page',
    '/theUserIdentity/academicStaff/updateAcademicStaff',
    '/school/courseDefine/getRelEdu',
    '/theUserIdentity/classStudent/productTimeList',
    '/theUserIdentity/classStudent/pageClassroomReadingStudent',
    '/theUserIdentity/classroomStudentLeave/leaveActQueryByPage',
    '/theUserIdentity/sysSignPoint/add',
    '/theUserIdentity/sysSignPoint/list',
    '/theUserIdentity/sysSignPoint/delete',
    '/theUserIdentity/sysSignPoint/update',
    '/theUserIdentity/sign/sch/tea/total',
    '/sign/sch/query/tea',
    '/sign/sch/put/tea',
    '/theUserIdentity/sign/sch/put/tea/clearSignTime',
    '/sign/sch/del/tea',
    '/sign/sch/tea/total',
    '/theUserIdentity/classTeacher/getTeaSign',
    '/theUserIdentity/classTeacher/deleteTeacherSign',
    '/theUserIdentity/sign/sch/tea/resign',
    '/theUserIdentity/classroomStudentLeave/listByDetailId',
    '/theUserIdentity/dataStatistics/enrollStatistics',
    '/theUserIdentity/dataStatistics/enrollStatisticsDataExport',
    '/theUserIdentity/classStudent/exportUnPartitionPage',
    '/theUserIdentity/classTeacher/getDetailWithTeaSignBatch',
    '/theUserIdentity/classroomSign/getTimeScope',
    '/theUserIdentity/courseDefine/getCourseDefineExport',
    '/theUserIdentity/dataSearch/searchTeachers',
    '/theUserIdentity/academicStaff/updateDutyTeacher',
    '/theUserIdentity/academicStaff/addDutyTeacher',
    '/theUserIdentity/leave/batchLeaveAudit',
    '/theUserIdentity/leave/batchChangeLeaveCanRefund',
    '/theUserIdentity/sysTeacherInfoExs/pageSysTeacher',
    '/theUserIdentity/sysTeacherInfoExs/teachersStatistics',
    '/theUserIdentity/sysTeacherInfoExs/getSysTeacherInfo',
    '/theUserIdentity/sysTeacherInfoExs/updateSysTeacher',
    '/theUserIdentity/sysTeacherInfoExs/pageTermTeacherTaughtSchool',
    '/theUserIdentity/sysTeacherInfoExs/pageTermTeacherTeachClass',
    '/theUserIdentity/sysTeacherInfoExs/exportSysTeacher',
    '/theUserIdentity/sysTeacherInfoExs/searchTeachers',
    '/theUserIdentity/sysTeacherInfoExs/batchAddSysTeacher',
    '/theUserIdentity/sysTeacherInfoExs/queryExistingTeachers',
    '/theUserIdentity/sysTeacherInfoExs/removeTeacher',
    '/theUserIdentity/classPartition/waitBindSignPage',
    '/theUserIdentity/classStudent/waitBindSignPage',
    '/theUserIdentity/classStudent/exportWaitBindSign',
    '/theUserIdentity/classStudent/studentHistoryClassroomAndSign',
    '/theUserIdentity/classStudent/studentHistoryClassroomSign',
    '/theUserIdentity/classStudent/studentHistoryAllSign',
    '/theUserIdentity/classStudent/studentHistoryClassroomAndSign',
    '/theUserIdentity/leave/studentLeaveStat',
    '/theUserIdentity/leave/leaveCanRefundStat',
    '/theUserIdentity/leave/pageLeaveCanRefund',
    '/theUserIdentity/classroomSign/classSignsPerMonthPage',
    '/theUserIdentity/classroomSign/classSignsPerMonthExport',
    '/courseClass/listAreaByOrgId',
    '/theUserIdentity/courseClassCombos/productPackageExport',
    '/theUserIdentity/courseClass/updateSortTime',
    '/theUserIdentity/classStudent/waitBindSignInClass',
    '/theUserIdentity/courseClassMaterial/getCourseClassMaterialPage',
    '/theUserIdentity/courseClassMaterial/updateIsVisible',
    '/theUserIdentity/courseClassMaterial/courseClassMaterialExport',
    '/theUserIdentity/sign/setSignToAbsent',
    '/theUserIdentity/classroomMien/getClassroomMienList',
    '/theUserIdentity/classroomMien/exportClassroomMienList',
    '/theUserIdentity/leave/teacherLeavePage',
    '/theUserIdentity/leave/batchTeacherLeaveAudit',
    '/theUserIdentity/leave/deleteTeacherLeave',
    '/theUserIdentity/leave/teacherLeaveExport',
    '/theUserIdentity/sign/teacherSignCollectPage',
    '/theUserIdentity/sign/teacherSignCollectExport',
    '/theUserIdentity/sign/teacherSignCollectExport',
    '/theUserIdentity/classStudent/waitSettleSignStudentPage',
    '/theUserIdentity/classStudent/waitSettleSignStudentExport',
    '/theUserIdentity/classStudent/waitSettleSignStudentDataStatistics',
    '/theUserIdentity/classPartition/openClassNotice',
    '/theUserIdentity/classroomStudentLeave/createBatchLeaveStudentImportTask',
    '/theUserIdentity/classroomStudentLeave/getBatchLeaveStudentImportResult',
    '/theUserIdentity/classroomStudentLeave/batchSaveImportLeaveStudent',
    '/theUserIdentity/courseClassDetail/batchSetTeaCheckInLimit',
    '/theUserIdentity/classroomStudentLeave/requestLeaveOrderStatistics',
    '/theUserIdentity/classroomStudentLeave/requestLeaveOrderPage',
    '/theUserIdentity/daycareSign/findCanDaycarePage',
    '/theUserIdentity/daycareSign/findDaycarePage',
    '/theUserIdentity/daycareSign/findDaycareDetailPage',
    '/theUserIdentity/daycareSign/daycare',
    '/theUserIdentity/daycareSign/cancelDaycare',
    '/theUserIdentity/sign/sch/statisticSchStuSign',
    '/theUserIdentity/regionalCourseTimeAdjustment/getAdjustmentRecPage',
    '/theUserIdentity/regionalCourseTimeAdjustment/add',
    '/theUserIdentity/adjustCourseTimeRecs/pageByCondition',
    '/theUserIdentity/khOrg/page',
    '/theUserIdentity/khOrg/addOrg',
    '/theUserIdentity/khOrg/updateOrg',
    '/theUserIdentity/khOrg/delOrg',
    '/theUserIdentity/hangingInfo/page',
    '/theUserIdentity/hangingInfo/addHangingInfo',
    '/theUserIdentity/hangingInfo/updateHangingInfo',
    '/theUserIdentity/hangingInfo/delHangingInfo',
    '/theUserIdentity/hangingInfo/export',
    '/theUserIdentity/hangingDivideRules/page',
    '/theUserIdentity/hangingDivideRules/addRule',
    '/theUserIdentity/hangingDivideRules/updateRule',
    '/theUserIdentity/hangingDivideRules/delRule',
    '/theUserIdentity/adjustCourseTimeRecs/pageByCondition',
    '/theUserIdentity/dataStatistics/queryClassCoursePeriodStatisticPage',
    '/theUserIdentity/dataStatistics/exportClassCoursePeriodStatisticPage'
  ];
  return httpUrl;
}
export function orderUrl() {
  // 订单
  const httpUrl = [
    '/theUserIdentity/UserOrder/leaveCanRefundCheck',
    '/theUserIdentity/enrollStatistic/currentSemesterStatistics',
    '/theUserIdentity/enrollStatistic/getRevenueDataStatistic',
    '/theUserIdentity/enrollStatistic/toRemind',
    '/theUserIdentity/org/page',
    '/edu/enrollStatistic/getStuEnrollNum',
    '/edu/enrollStatistic/getEnrollNum',
    '/edu/enrollStatistic/getPaymentInfo',
    '/edu/enrollStatistic/getRefundInfo',
    '/edu/enrollStatistic/getCourseNum',
    '/edu/enrollStatistic/getCourseClassNum',
    '/edu/enrollStatistic/getCourseClassDetailNum',
    '/edu/enrollStatistic/statEnrollNumOfCourseTypeKind',
    '/edu/enrollStatistic/statOpenClassNumOfCourseTypeKind',

    '/userOrder/listRefundByOrderId',
    '/userOrder/refundOrderDetail',
    '/theUserIdentity/UserOrder/batchRefund',
    '/theUserIdentity/UserOrder/mainProductExport',
    '/theUserIdentity/UserOrder/mainOrderExport',
    '/theUserIdentity/userOrder/getRefundDtl',
    '/userOrder/updatePreOrderPayTime',
    // '/userOrder/theUserIdentity/courseOrderPage',
    '/theUserIdentity/UserOrder/courseOrderPage',
    '/userOrder/courseOrderDetail',
    '/userOrder/orgOrderPage',
    '/userOrder/foodOrgOrderPage',
    '/userOrder/refund',
    '/userOrder/orgRefundOrderPage',
    '/userOrder/foodOrgRefundOrderPage',
    '/userOrder/refundFood',
    '/userOrder/orgRefundOrderPage',
    '/userOrder/confirmRefund',
    '/userOrder/schoolOrderPage',
    '/userOrder/schoolRefundOrderPage',
    '/fund/withdraw',
    '/userOrder/org/adjustOrdFeePage',
    '/userOrder/sys/adjustOrdFeePage',
    '/userOrder/org/adjustOrdFee',
    '/userOrder/sysOrderPage',
    '/theUserIdentity/UserOrder/refundOrderPage',
    '/userOrder/sys/adjustOrdFee',
    '/userOrder/sysRefundOrderPage',
    '/theUserIdentity/settlementSheet/listOrgTally',
    '/theUserIdentity/settlementSheet/listSchoolTally',
    '/theUserIdentity/settlementSheet/getOrgTallyDetail',
    '/theUserIdentity/settlementSheet/getSchoolTallyDetail',
    '/theUserIdentity/settlementSheet/uploadStatementSheetImg',
    '/theUserIdentity/settlementSheet/getStatementSheetImg',
    '/org/settlementSheet/getStatementSheetImg',
    '/org/settlementSheet/uploadStatementSheetImg',
    '/edu/settlementSheet/getStatementSheetImg',
    '/theUserIdentity/settlementSheet/confirm',
    '/theUserIdentity/settlementSheet/revoke',
    '/theUserIdentity/settlementSheet/getProductTallyOrderDetailList',
    '/school/settlementSheet/getProductTallyOrderDetailList',
    '/org/settlementSheet/getProductTallyOrderDetailList',
    '/edu/settlementSheet/getProductTallyOrderDetailList',
    '/theUserIdentity/settlementSheet/exportProductTallyOrderDetail',
    '/school/settlementSheet/exportProductTallyOrderDetail',
    '/org/settlementSheet/exportProductTallyOrderDetail',
    '/edu/settlementSheet/exportProductTallyOrderDetail',
    '/userOrder/getTaskId',
    '/edu/settlementSheet/getTallyOrderDetail',
    '/edu/settlementSheet/getOrgTallyDetail',
    '/org/settlementSheet/listOrgTally',
    '/org/settlementSheet/getOrgTallyDetail',
    '/edu/settlementSheet/exportTallyOrderDetail',
    '/school/settlementSheet/listSchoolTally',
    '/school/settlementSheet/getSchoolTallyDetail',
    '/edu/UserOrder/getProcessConfiguration',
    '/edu/settlementSheet/getAuditDetail',
    '/edu/settlementSheet/confirm',
    '/edu/settlementSheet/reject',
    '/edu/UserOrder/addAuditNode',
    '/edu/UserOrder/updateAuditNode',
    '/org/UserOrder/findBankCardInfo',
    '/theUserIdentity/UserOrder/findBankCardInfo',
    '/edu/settlementSheet/listTallyOrder',
    '/theUserIdentity/UserOrder/refundOrderExport', // 退款订单列表导出
    '/theUserIdentity/divideConfig/configRelPage', // 分页查询机构分账配置记录 2022-08-04
    '/theUserIdentity/divideConfig/findBankList',

    '/theUserIdentity/UserOrder/packageOrderPage',
    '/theUserIdentity/UserOrder/packageOrderDetail',
    '/theUserIdentity/UserOrder/packageOrderPageExport',
    '/theUserIdentity/UserOrder/packageSonOrderExport',
    '/school/UserOrder/packageOrderPage',
    '/school/UserOrder/packageOrderDetail',
    '/org/UserOrder/packageOrderPage',
    '/org/UserOrder/packageOrderDetail',
    '/edu/UserOrder/packageOrderPage',
    '/edu/UserOrder/packageOrderDetail',
    '/school/UserOrder/packageOrderPageExport',
    '/school/UserOrder/packageSonOrderExport',
    '/org/UserOrder/packageOrderPageExport',
    '/org/UserOrder/packageSonOrderExport',
    '/edu/UserOrder/packageSonOrderExport',
    '/edu/UserOrder/packageOrderPageExport',
    '/theUserIdentity/UserOrder/courseOrderDetail', // 新版订单详情 2022.07.22
    '/theUserIdentity/batchRefund/page', // 获取批量退款订单列表
    '/theUserIdentity/batchRefund/listDetail',
    '/theUserIdentity/batchRefund/listSign',
    '/theUserIdentity/batchRefund/countSign',
    '/theUserIdentity/batchRefund/createBatchRefund', // 创建批量退款
    '/theUserIdentity/batchRefund/getCreateMsgByBatchRefundId', // 查询批量创建退款申请结果
    '/theUserIdentity/batchRefund/getCreateMsgByBatchRefundIdStatistics', // 查询创建批量退款创建结果统计
    '/theUserIdentity/batchRefund/exportCreateMsgByBatchRefundId', // 下载批量创建退款申请结果
    '/theUserIdentity/batchRefund/confirmBatchRefund', // 审批批量退款
    '/theUserIdentity/batchRefund/startClassFailRefund',
    '/theUserIdentity/batchRefund/startClassFailRefundCheck',
    '/theUserIdentity/batchRefund/detail',
    '/theUserIdentity/batchRefund/export', // 下载学生名单
    '/theUserIdentity/divideConfig/findBankModeList',
    '/theUserIdentity/divideConfig/getAcctTypes',
    '/theUserIdentity/divideConfig/save',
    '/theUserIdentity/divideConfig/page',
    '/theUserIdentity/divideConfig/detail',
    '/theUserIdentity/divideConfig/schoolPage',
    '/theUserIdentity/divideConfig/orgPage',
    '/theUserIdentity/divideConfig/schoolList',
    '/theUserIdentity/divideConfig/relateSch',
    '/theUserIdentity/divideConfig/findAccountList',
    '/theUserIdentity/divideConfig/orgList',
    '/theUserIdentity/divideConfig/relateOrg',
    '/theUserIdentity/divideConfig/update',
    '/theUserIdentity/settlementSheet/confirm',
    '/theUserIdentity/settlementSheet/delaySettle',
    '/org/settlementSheet/getAuditDetail',
    '/theUserIdentity/settlementSheet/getAuditDetail',
    '/theUserIdentity/settlementSheet/listTallyOrder',
    '/theUserIdentity/settlementSheet/getTallyOrderDetail',
    '/theUserIdentity/settlementSheet/getSettlementSheetStatus',
    '/theUserIdentity/settlementSheet/exportTallyOrderDetail',
    '/userOrder/isOutMchPayMode',
    '/userOrder/cancelRefundOrder',
    '/theUserIdentity/UserOrder/queryStudentsOrderStatistics',
    '/theUserIdentity/settlementSheet/exportAgencyBillList',
    '/theUserIdentity/coursefeeAllotPlans/pageByCondition',
    '/theUserIdentity/coursefeeAllotPlans/addCoursefeeAllotPlan',
    '/theUserIdentity/coursefeeAllotPlans/deleteCoursefeeAllotPlan',
    '/theUserIdentity/coursefeeAllotPlans/getDetailByPlanId',
    '/theUserIdentity/coursefeeAllotPlans/updateCoursefeeAllotPlan',
    '/theUserIdentity/coursefeeAllotPlans/pageSchRelPlan',
    '/theUserIdentity/coursefeeAllotPlans/unsetOneSchRelPlan',
    '/theUserIdentity/coursefeeAllotPlans/setSchRelPlan',
    '/theUserIdentity/settlementSheetSch/schoolSignConfirmList',
    '/theUserIdentity/settlementSheetSch/teachersSignConfirmList',
    '/theUserIdentity/settlementSheetSch/schoolSettleConfirmationRecords',
    '/theUserIdentity/settlementSheetSch/statisticalConfirmation',
    '/theUserIdentity/settlementSheetSch/supplementalRecords',
    '/theUserIdentity/settlementSheetSch/cancelPayroll',
    '/theUserIdentity/settlementSheetSch/supplemental',
    '/theUserIdentity/settlementSheetSch/teacherSignConfirmationDetails',
    '/theUserIdentity/settlementSheetSch/operationConfirmed',
    '/theUserIdentity/settlementSheetSch/toWithdrawConfirmed',
    '/theUserIdentity/settlementSheetSch/schoolSignConfirmDetails',
    '/theUserIdentity/settlementSheetSch/schoolApprovalPayrollList',
    '/theUserIdentity/settlementSheetSch/schoolSettleApproveRecords',
    '/theUserIdentity/settlementSheetSch/confirmSingleChangeList',
    '/theUserIdentity/settlementSheetSch/confirmSingleChange',
    '/school/settlementSheetSch/schoolSignConfirmList',
    '/school/settlementSheetSch/schoolConfirmed',
    '/theUserIdentity/settlementSheetSch/financialExaminationApprovalAuthority',
    '/theUserIdentity/settlementSheetSch/financialConfirmed',
    '/theUserIdentity/divideConfig/saveSch',
    '/theUserIdentity/divideConfig/updateSch',
    '/theUserIdentity/batchRefund/cancelBatchRefund',
    '/theUserIdentity/batchRefund/exportBatchRefund',
    '/theUserIdentity/settlementSheet/resetBillingOperations',
    '/theUserIdentity/settlementSheet/exportListSchoolTally',
    '/theUserIdentity/UserOrder/manualProcessingRefund', // 退款失败手动处理
    '/theUserIdentity/divideConfig/ ',
    '/theUserIdentity/settlementSheetSch/batchSupplemental',
    '/theUserIdentity/settlementSheetSch/merchantsAdministratorInfo',
    '/theUserIdentity/settlementSheetSch/settlementProgress',
    '/theUserIdentity/settlementSheetSch/schoolIncomeStatistics',
    '/theUserIdentity/settlementSheetSch/querySchoolTeachers',
    '/theUserIdentity/settlementSheetSch/remittanceTransferDetails',
    '/theUserIdentity/settlementSheetSch/addSingleArticleTeachersSalaries',
    '/theUserIdentity/settlementSheetSch/sendMsg',
    '/commons/isPingAnAccount',
    '/theUserIdentity/schExpenseTransRecs/pageByCondition',
    '/theUserIdentity/schExpenseTransRecs/getOutAccountPage',
    '/theUserIdentity/schExpenseTransRecs/getOutAccountInfo',
    '/theUserIdentity/schExpenseTransRecs/sendTransExpenseMsg',
    '/theUserIdentity/schExpenseTransRecs/expenseTrans',
    '/theUserIdentity/schExpenseTransRecs/getInAcctHistory',
    '/theUserIdentity/schExpenseTransRecs/getExpenseTransDetail',
    '/theUserIdentity/schExpenseTransRecs/sumAmount',
    '/theUserIdentity/UserOrder/orderDataStatistics',
    '/edu/settlementSheet/eduBillStatistics',
    '/commons/getYearTermList',
    '/theUserIdentity/settlementSheetSch/importSettlementSheetSchItem',
    '/theUserIdentity/settlementSheetSch/createMonthSheet',
    '/theUserIdentity/settlementSheetSch/delSheetItem',
    '/theUserIdentity/UserOrder/countRefund',
    '/theUserIdentity/settlementSheet/toSettleBillDetails',
    `/theUserIdentity/settlementSheet/getConfigOrgList`,
    `/theUserIdentity/settlementSheetSch/findSchList`,
    '/divideConfig/configRelList',
    `/theUserIdentity/settlementSheet/wechat/confirm`,
    '/theUserIdentity/schExpenseTransRecs/updateAttachPhotos',
    '/theUserIdentity/enrollStatistic/courseRegistrationData',
    '/theUserIdentity/enrollStatistic/courseIncomeData',
    '/theUserIdentity/enrollStatistic/exportCourseRegistrationData',
    '/theUserIdentity/enrollStatistic/exportCourseIncomeData',
    `/theUserIdentity/settlementSheet/batchConfirmSettleSheet`,
    '/theUserIdentity/UserOrder/refundOrderListBySettlementId',
    '/theUserIdentity/settlementSheetSch/deletePayroll',
    '/theUserIdentity/offerCoupon/addCoupons',
    '/theUserIdentity/offerCoupon/pageOfferCoupons',
    '/theUserIdentity/offerCoupon/getCoupons',
    '/theUserIdentity/offerCoupon/editCoupons',
    '/theUserIdentity/offerCoupon/invalidCoupon',
    '/theUserIdentity/offerCoupon/pageCouponsUsersDetail',
    '/theUserIdentity/offerCoupon/couponsCourseGoodsShallApply',
    '/theUserIdentity/offerCoupon/couponsIssuedRangeQueries',
    '/theUserIdentity/offerCoupon/disableUserCoupons',
    '/theUserIdentity/offerCoupon/exportCouponsList',
    '/theUserIdentity/offerCoupon/exportCouponsUsersDetail',
    '/theUserIdentity/offerCoupon/sendMsg',
    '/theUserIdentity/offerCoupon/batchIssueCoupons',
    '/theUserIdentity/settlementSheet/getBankIdOrgByAreaCode',
    '/userOrder/getMaterialAvailableRefundAmountByTimes',
    '/theUserIdentity/UserOrder/materialOrderPage',
    '/theUserIdentity/UserOrder/materialOrderExport',
    '/theUserIdentity/UserOrder/materialOrderDataStatistics',
    '/theUserIdentity/userOrdOffSettle/canSettleMaterials',
    '/theUserIdentity/settlementSheet/batchMaterialWithholdCompute',
    '/userOrder/callPendingPaymentOrders',
    '/theUserIdentity/UserOrder/downloadOrderImportTemplate',
    `/theUserIdentity/UserOrder/parsingImportOrder`,
    '/theUserIdentity/UserOrder/commitImportOrder',
    '/theUserIdentity/UserOrder/closeOrder',
    '/theUserIdentity/divideConfig/orgPage',
    '/theUserIdentity/divideConfig/deleteRelById',
    '/theUserIdentity/divideConfig/updateMainRelOrg',
    '/theUserIdentity/mergedDivideSheet/subSheetListPage',
    '/theUserIdentity/mergedDivideSheet/exportSubSheetList',
    '/theUserIdentity/mergedDivideSheet/schoolSheetListPage',
    '/theUserIdentity/mergedDivideSheet/exportSchoolSheetList',
    '/theUserIdentity/mergedDivideSheet/subOrgSheetDetailsList',
    '/theUserIdentity/mergedDivideSheet/subSheetList',
    '/theUserIdentity/mergedDivideSheet/billOrderLedgerDetails',
    '/theUserIdentity/mergedDivideSheet/batchAcademicAffairsApproval',
    '/theUserIdentity/mergedDivideSheet/batchAcademicAffairsRevocationApproval',
    '/theUserIdentity/mergedDivideSheet/operationsApproval',
    '/theUserIdentity/mergedDivideSheet/billOrderDetailsStatistics',
    '/theUserIdentity/mergedDivideSheet/operationRevocationApproval',
    '/theUserIdentity/mergedDivideSheet/providerApproval',
    '/theUserIdentity/mergedDivideSheet/sendRecipientApprovalVerificationSms',
    '/theUserIdentity/mergedDivideSheet/payeeApproval',
    '/theUserIdentity/mergedDivideSheet/uploadBillReviewForm',
    '/theUserIdentity/mergedDivideSheet/getBillReviewForm',
    `/theUserIdentity/mergedDivideSheet/batchOperationsApproval`,
    `/theUserIdentity/mergedDivideSheet/eduPreApproval`,
    `/theUserIdentity/mergedDivideSheet/eduApproval`,
    '/theUserIdentity/mergedDivideSheet/queryAndApproveSplitBills',
    '/theUserIdentity/mergedDivideSheet/exportEduSubSheet',
    '/theUserIdentity/mergedDivideSheet/exportBillOrderLedgerDetails',
    '/theUserIdentity/mergedDivideSheet/querySheetAssociatedSchool',
    '/theUserIdentity/mergedDivideSheet/querySheetAssociatedOrg',
    '/theUserIdentity/mergedDivideSheet/querySheetAssociatedStatementOrg',
    '/userOrder/queryCallableOrders',
    `/userOrder/bulkCallPendingPaymentOrders`,
    '/theUserIdentity/UserOrder/createCourseOrderAsync',
    '/userOrder/revampRefundSign',
    '/theUserIdentity/settlementSheetFiles/listByObjIdAndTypes',
    '/theUserIdentity/settlementSheetFiles/uploadBillReviewForm',
    '/theUserIdentity/mergedDivideSheet/billOrderDetailsStatisticsTotal',
    '/theUserIdentity/SettlementFileDownloadRec/page',
    '/theUserIdentity/SettlementFileDownloadRec/add',
    '/theUserIdentity/SettlementFileDownloadRec/delete',
    '/theUserIdentity/thirdPlatSettleSheet/queryPageByCondition',
    '/theUserIdentity/thirdPlatSettleSheet/exportByCondition',
    '/theUserIdentity/thirdPlatSettleSheet/getDetailBySheetId',
    '/theUserIdentity/thirdPlatSettleSheet/generateThirdPlatSettleSheetDetailPdfFile',
    '/theUserIdentity/thirdPlatSettleSheet/pageOrderSettlementDetail',
    '/theUserIdentity/thirdPlatSettleSheet/exportOrderSettlementDetail',
    '/theUserIdentity/thirdPlatSettleSheet/settleSheetRelOrgPage',
    '/theUserIdentity/requestRefundSheet/getSheetListPage',
    '/theUserIdentity/UserOrder/requestRefundOrderPage',

    '/theUserIdentity/requestRefundSheet/exportSheetList',
    '/theUserIdentity/requestRefundSheet/getSheetDetail',
    '/theUserIdentity/requestRefundSheet/sheetDetailPdfFile',
    '/theUserIdentity/UserOrder/requestLeaveRefundOrderPage',
    '/theUserIdentity/UserOrder/exportRequestLeaveRefundOrders',
    '/theUserIdentity/UserOrder/requestRefundOrderStatistics',

    '/theUserIdentity/requestRefundSheet/add',
    '/theUserIdentity/requestRefundSheet/confirm',
    '/theUserIdentity/requestRefundSheet/revoke',
    '/theUserIdentity/requestRefundSheet/delete',
    '/theUserIdentity/requestRefundSheet/removeItems',
    '/theUserIdentity/requestRefundSheet/appendItems',
    '/theUserIdentity/thirdPlatSettleSheet/add',
    '/theUserIdentity/thirdPlatSettleSheet/delete'
  ];
  return httpUrl;
}
// 基础库
export function basestoreUrl() {
  const httpUrl = [
    '/class/listClass',
    // 机构学期管理
    '/sysTermBureauOrgs/list',
    '/sysTermBureauOrgs/add',
    '/sysTermBureauOrgs/update',
    '/sysTermBureauOrgs/listRelOrg',
    '/sysTermBureauOrgs/addRelOrg',
    '/sysTermBureauOrgs/updateRelOrg',
    '/sysTermBureauOrgs/deleteRelOrg',
    // 首页数据面板
    '/sysTermBureauOrgs/getStatisticInfo',
    // 基础平台字典
    '/dictionary/getByDictCode',
    // 获取用户身份
    '/user/account',
    // 切换登录
    '/user/reLogin',
    // 课程分类-其他设置
    '/sysStaticDatas/getOtherSetting',
    '/theUserIdentity/sysStaticDatas/getOtherSetting', //  // 课程设置 - 其他设置
    '/sysStaticDatas/saveSysStaticData',
    '/theUserIdentity/sysStaticDatas/saveSysStaticData',
    '/file/upload/token',
    '/file/down/token',
    '/sysOrganizations',
    '/file/url',
    '/sysOrganizationBranchs/orgBranch',
    '/schoolOrgRel/orgSchoolName',
    '/student/orgSchoolStudent',
    '/student/queryListSchoolIds',
    '/sysGrades/school/grades',
    '/class/listClass',
    '/sysGrades/listOrgGradeClass',
    '/class/school/classes',
    '/yearTerms/listTerms',
    '/yearTerms/schoolTerms',

    '/interface/api/49083',
    '/yearTerms/term',
    '/sysSchools/school/associatedOrg',
    '/sysOperators/operatorList',
    '/sysOperators/operator',
    '/sysOperators/operator/pwd',
    '/sysOrganizations/listOrganizations',
    '/sysOrganizations/status',
    '/sysOrganizations/organizations',
    '/sysOrganizations/organization',
    '/sysSchools/listSchools',
    '/sysSchools/exportSchoolsNew',
    '/educationBureau/listBureau',
    '/sysOrganizationBranchs/orgBranch',
    '/sysOrganizationBranchs/branch',
    '/teacher/queryList',
    '/teacher/delete',
    '/teacher/add',
    '/teacher/changePassword',
    '/teacher/update',
    '/sysSchools/schoolDetail',
    '/sysSchools/school',
    '/student/querylist',
    '/dictionary/getByDictCode',
    '/student/getStudentList',
    '/student/getByUserId',
    '/student/exportStudentList',
    '/student/exportGraduateStudent',
    '/student/listByGraduateStudent',
    '/educationBureau/recommendBureau',
    '/orgEducationBureaus/orgRecommends',
    '/orgEducationBureaus/edu/org/term',
    '/sysOrganizations/organizationUpdateDetail',
    '/sysOrganizations/organization',
    '/educationBureau/educationBureau',
    '/educationBureau/educationBureau',
    '/educationBureau/educationBureau',
    '/educationBureau/educationBureauNew',
    '/parent/add',
    '/parent/querySingle',
    '/student/add',
    '/student/update',
    '/student/delete',
    '/parent/querylist',
    '/parent/update',
    '/sysSchools/school',
    '/sysSchools/schoolDetail',
    '/sysSchools/sysSchool',
    '/sysSchools/associatedOrg',
    '/sysOperators/operatorList',
    '/sysOperators/operator',
    '/sysOperators',
    '/sysOperators/org/operator',
    '/sysOperators/operator/pwd',
    '/sysOperators/operator',
    '/sysSchools/schoolStatu',
    '/teacher/queryList/org',
    '/sys/places/querylist',
    '/sys/places/type/querylist',
    '/sys/places/add',
    '/sys/places/type/add',
    '/sys/places/type/update',
    '/sys/places/update',
    '/sys/places/delete',
    '/sys/places/type/delete',
    '/teacher/DynamicList',
    '/sysSchools/listAll',
    '/parent/delete',
    '/parent/export',
    '/student/export',
    '/teacher/export/school',
    '/teacher/export/org',
    '/sysSchools/school',
    '/educationBureau/educationBureau/statu',
    '/orgEducationBureaus/edu/org',
    '/class/class',
    '/class/exportByCondition',
    '/sysGrades/grade',
    '/sysGrades/gradeGraduate',
    '/educationBureau/eduBureau',
    '/class',
    '/sysSchools/school/removeOrg',
    '/sysOrgWeixinAccts',
    '/orgEducationBureaus/edu/org',
    '/educationBureau/edu/detail',
    '/sys/places/schoolPlaceList',
    '/theUserIdentity/notice/queryNotice',
    '/notice/deleteNotice',
    '/notice/queryNoticeDetail',
    '/notice/queryNoticeReadDetail',
    '/notice/reviewNotice',
    '/msg',
    '/msg/code',
    '/msg/num',
    '/sysSchools/school/associatedOrg/detail',
    '/notice/addNotice',
    '/notice/updateNotice',
    '/msg/all',
    '/sysSchools/remind',
    '/notice/exportNoticeReadDetail',
    '/stat/org/stat/school',
    '/stat/org/stat/courseDefine',
    '/stat/org/stat/courseClass/sign',
    '/student/import',
    '/parent/import',
    '/teacher/importTeacher',
    '/educationBureau/passAudit',
    '/teacher/querySchoolOrgTeacher',
    '/sysOrganizations/new/listOrganizations',
    '/wxcorp/corpStuSecret',
    '/sysSchools/qywx/school',
    '/wxcorp/corpSecret',
    '/schoolPublishs/listByType',
    '/schoolPublishs/detail',
    '/sysOrganizations/listMerchants',
    '/sysOrganizations/organizationsV3',
    '/sysOrganizations/organizationUpdateV3',
    '/sysOrganizations/organizationMerchantInfo',
    '/sysBanner/list',
    '/sysBanner/listOrgSch',
    '/sysBanner/delete',
    '/sysBanner/banner',
    '/sysBanner/updateBanner',
    // 学校首页
    '/stat/school/view/basicData',
    '/stat/school/view/revenue',
    '/stat/school/view/top5',
    '/stat/school/view/tuoguan',
    '/stat/school/sch/food',
    '/stat/school/view/courseType',
    // 学校-机构统计页
    '/stat/school/view/org/basicData',
    '/stat/school/view/org/top5',
    '/stat/school/view/org/tuoguan',
    '/stat/school/view/org/courseType',
    '/stat/school/sch/org/food',
    // 机构首页
    '/stat/org/view/org/basicData',
    '/stat/org/view/revenue',
    '/stat/org/view/org/top5',
    '/stat/org/org/food',
    '/stat/org/view/org/tuoguan',
    '/stat/org/view/org/courseType',
    // 机构-学校统计页
    '/stat/org/view/org/sch/basicData',
    '/stat/org/view/org/sch/top5',
    '/stat/org/org/sch/food',
    '/stat/org/view/org/sch/tuoguan',
    '/stat/org/view/org/sch/courseType',
    // 教育局 - 首页
    '/stat/edu/org/edu/food',
    '/stat/edu/view/edu/basicData',
    '/stat/edu/view/edu/sign',
    '/stat/edu/view/edu/top5',
    '/stat/edu/view/edu/day',
    '/stat/edu/view/edu/top5',
    '/stat/edu/view/edu/tuoguan',
    '/stat/edu/view/org/courseType',
    '/bigdataReport/get',

    // 教育局 - 学校统计
    '/stat/edu/view/edu/sch/basicData',
    '/stat/edu/view/edu/sch/top5',
    '/stat/edu/org/edu/sch/food',
    '/stat/edu/view/edu/sch/tuoguan',
    '/stat/edu/view/edu/sch/courseType',
    // 教育局 - 机构统计
    '/stat/edu/view/edu/org/basicData',
    '/stat/edu/view/edu/revenue',
    '/stat/edu/view/edu/org/top5',
    '/stat/edu/org/edu/org/food',
    '/stat/edu/view/edu/org/tuoguan',
    '/stat/edu/view/edu/org/courseType',
    // 平台端 - 首页
    '/stat/plat/basicData',
    '/stat/plat/revenueData',
    '/stat/plat/day',
    '/stat/plat/tuoguan',
    '/stat/plat/courseType',
    '/stat/school/view/CourseType',
    '/sysOrganizations/merchantIsAvailable',
    '/user/sendMsg',
    '/user/sendPCMsg',
    '/user/sendMsgToPcLogin',
    '/user/phone',
    // 公共-获取菜单
    '/auth/menu',
    // 教育局 v1.3.1
    '/educationBureau/listBureauNew',
    '/educationBureau/educationBureauNew',
    '/educationBureau/getEduAreaName',
    '/educationBureau/getRelOrg',
    '/orgEducationBureaus/edu/org/new',
    '/educationBureau/recommendBureauNew',
    '/sysSchools/associatedOrgNew',
    '/orgEducationBureaus/edu/org/new',
    '/user/getOrgUser',
    // 学校端 v1.3.1
    '/sysSchools/listSchoolsNew',

    '/sysSchools/getSchoolDetailNew',
    '/sysSchools/school/associatedOrgNew',
    '/teacher/allUserList',
    '/sysSchools/school/associatedOrg/detail/new',
    '/sysSchools/school/removeOrgNew',
    // 机构 v1.3.1
    '/sysOrganizations/listOrganizationsNew',
    '/sysOrganizations/new/listOrganizationsNew',
    '/sysOrganizations/organizationNew',
    '/sysOrganizations/getRelBureau',
    '/sysOrganizations/getRelSchool',
    '/sysOrganizations/organizationMerchantInfoNew',
    '/sysOrganizations/updateOrgName',
    '/orgEducationBureaus/orgRecommendsNew',
    '/sysSchools/getSchoolOrgNew',
    '/user/captcha',
    '/sysOperators/operatorListNew',
    '/schoolOrgRel/pageOrgSchoolName',
    '/user/sendLoginMsg', // 校验当前登录人的手机号
    '/user',
    '/notice/queryNoticeByNoticeId',
    '/notice/noticeSave',
    '/notice/update',
    '/notice/queryNoticeReadDetail',
    '/notice/delByNoticeId',
    '/notice/updateNoticeState',
    '/sysStaticDatas/listSystemRemind',
    '/sysStaticDatas/updateSystemRemind',
    '/notice/exportNoticeReadDetail',
    '/notice/queryNoticeObjectByNoticeId',
    '/notice/objectSaveList',
    '/notice/classroomNumDistinct',
    '/sysSchools/listAreaCode',
    '/theUserIdentity/sysStaticDatas/switchPayWages',
    '/theUserIdentity/sysStaticDatas/setTeaSignDayScope',
    '/theUserIdentity/sysStaticDatas/switchSignPlace',
    '/theUserIdentity/sysSchools/schoolPage', // v2.1.18
    '/auth/checkAppPermissionSets',
    '/auth/checkPermissionSets',
    '/common/getIpAddr',
    '/theUserIdentity/sysSchools/parentsSmallProgramCode',
    '/theUserIdentity/sysStaticDatas/sysStaticDataRecPage',
    '/sysYearTerm/getYearTermDict',
    '/theUserIdentity/sysStaticDatas/sysStaticDataRecPage',
    '/sysYearTerm/getYearTermList',
    '/admin/sysYearTerm/addYearTerm',
    '/admin/sysYearTerm/updateYearTerm',
    '/admin/sysYearTerm/checkYearTerm',
    '/sysYearTerm/getPresentYearTerm',
    '/theUserIdentity/common/org',
    '/theUserIdentity/operateRec/operateRecPage',
    '/common/schoolSettlementSheetDownRec',
    '/sysTermBureauOrgs/existListRelOrg',
    '/edu/sysTermBureauOrgs/eduRelBasicSchool',
    // 任务中心
    '/theUserIdentity/batchProcData/page',
    '/theUserIdentity/batchProcData/qryTaskProgress',
    '/theUserIdentity/sysTermBureauOrgs/termServiceSchoolNumber',
    '/theUserIdentity/batchProcData/ingList',
    '/common/orgSettlementSheetDownRec',
    '/admin/common/adminOrgPage',
    '/theUserIdentity/sysStaticDatas/getSignet',
    `/theUserIdentity/sysStaticDatas/saveOrUpdateSignet`,
    `/admin/sysStaticDatas/deleteSignet`,
    '/admin/sysStaticDatas/getLogo',
    `/admin/sysStaticDatas/saveOrUpdateLogo`,
    `/theUserIdentity/sysStaticDatas/deleteSignet`,
    '/admin/sysStaticDatas/deleteLogo',
    '/theUserIdentity/sysStaticDatas/setAutoRefund',
    '/theUserIdentity/sysStaticDatas/batchSaveAutoRefund',
    '/theUserIdentity/sysStaticDatas/getAutoRefundDtoBySchoolId',
    '/theUserIdentity/template/serviceSigningAgreementPage',
    '/theUserIdentity/template/addTemplate',
    '/theUserIdentity/template/serviceSigningAgreementDetail',
    '/theUserIdentity/template/updateTemplate',
    '/theUserIdentity/sysSignStudent/studentServiceSigningAgreementPage',
    '/theUserIdentity/sysSignStudent/studentServiceSigningAgreementExport',
    '/theUserIdentity/sysSignStudent/pushMsgToParentReSign',
    '/file/preview/token',
    '/theUserIdentity/template/electronicReceiptPage',
    '/theUserIdentity/template/addTemplate',
    '/theUserIdentity/electronicReceipt/updateElectronicReceiptTemplate',
    '/theUserIdentity/template/electronicReceiptDetail',
    '/theUserIdentity/template/serviceSigningAgreementDefaultTemplate',
    '/theUserIdentity/template/batchSaveOpUpdateTemplate',
    '/theUserIdentity/template/electronicReceiptDefaultTemplate',
    '/theUserIdentity/sysStaticDatas/updateSchoolCode',
    '/theUserIdentity/sysStaticDatas/listOrg',
    '/theUserIdentity/sysStaticDatas/updateLimitTime',
    '/theUserIdentity/sysStaticDatas/updateLimitCondition',
    '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplatePage',
    '/theUserIdentity/serviceAgreementTemplate/deleteServiceAgreementTemplate',
    '/theUserIdentity/sysStaticDatas/getByCodeType',
    '/theUserIdentity/serviceAgreementTemplate/addServiceAgreementTemplate',
    '/theUserIdentity/common/eduRelOrg',
    '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplateDetail',
    '/theUserIdentity/common/schoolRelOrg',
    '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplateExport',
    '/theUserIdentity/serviceAgreementTemplate/updateServiceAgreementTemplate',
    '/theUserIdentity/serviceAgreementTemplate/serviceSigningAgreementDefaultTemplate',
    '/theUserIdentity/serviceAgreementTemplate/batchUpdateServiceAgreementTemplate',
    '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelOrg',
    '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelSchool',
    '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelPlat',
    '/theUserIdentity/serviceAgreementTemplate/deleteFileIdRelOrg',
    '/theUserIdentity/serviceAgreementTemplate/deleteFinalFile',
    '/theUserIdentity/serviceAgreementTemplate/saveFinalFileIdRelAgreement',
    '/theUserIdentity/serviceAgreementTemplate/updateConfigSts',
    '/theUserIdentity/electronicReceipt/page',
    '/theUserIdentity/electronicReceipt/electronicReceiptTemplateDetail',
    '/theUserIdentity/electronicReceipt/addElectronicReceiptTemplate',
    '/theUserIdentity/electronicReceipt/updateElectronicReceiptTemplate',
    '/file/previewServicePdf/token',
    '/theUserIdentity/serviceAgreementTemplate/getServiceAgreementTemplate',
    '/file/downServicePdf/token',
    '/theUserIdentity/batchProcData/qrySubTaskProgress',
    '/file/upload/ServicePdf/token',
    '/file/uploadServiceTemplatePdf/token',
    '/file/previewServiceTemplatePdf/token',
    '/file/downServiceTemplatePdf/token',
    `/theUserIdentity/sysStaticDatas/studentSignStatusNotification`,
    '/theUserIdentity/sysStaticDatas/setParentLeaveTimeLimit',
    '/theUserIdentity/sysStaticDatas/autoCheckLeavePass',
    '/edu/sysStaticDatas/configureSettlementApprovalProcess',
    '/common/getConfigureSettlementApprovalProcess',
    '/theUserIdentity/sysStaticDatas/setParentLeaveTimeLimit',
    '/theUserIdentity/sysStaticDatas/saveApproveRefundConfig',
    '/theUserIdentity/sysStaticDatas/BatchSaveApproveRefundConfig',
    '/theUserIdentity/sysStaticDatas/getApproveRefundDtoBySchoolId',
    '/common/getUserProtocol',
    '/admin/sysStaticDatas/saveConfig'
  ];
  return httpUrl;
}

// 订餐
export function mealUrl() {
  const httpUrl = [
    '/mealperiods',
    '/dishinfos',
    '/dailysupplyinfos',
    '/insoffers/qrystuordmeal',
    '/supplymealinfos',
    '/supplymealinfos/qrysuppmeal/page',
    '/insOfferDetail',
    '/supplymealinfos/getSupplyMealById',
    '/supplymealinfost',
    '/insoffers/mealNumberStatistics',
    '/insoffers/mealRevenueStatistics',
    '/insOfferDetail/export',
    '/dailysupplyinfos/dishinfos',
    '/supplymealinfos/listUnPubBySchool',
    '/supplymealinfos/publish',
    '/supplymealinfos/qrysuppmeal/page2School'
  ];
  return httpUrl;
}

// 模板
export function templateUrl() {
  const httpUrl = [
    '/daycareTemplate/detail',
    '/daycareTemplate/addCourse',
    '/daycareTemplate/addDaycare',
    '/daycareTemplate/org/delete',
    '/daycareTemplate/org/editDaycare',
    '/daycareTemplate/org/page',
    '/daycareTemplate/org/editCourse',
    '/daycareTemplate/school/courseClass/page',
    '/daycareTemplate/school/introduce/courseClass',
    '/theUserIdentity/courseDefine/addCourse',
    '/theUserIdentity/courseDefine/updateCourse',
    '/theUserIdentity/courseDefine/getCourseDetail'
  ];
  return httpUrl;
}

export function daycareUrl() {
  // 托管
  const httpUrl = [
    '/daycare/org/page',
    '/daycareTemplate/org/page',
    '/daycare/school/page',
    '/daycare/school/add',
    '/daycare/school/update',
    '/courseClass/publishClasses',
    '/daycareTemplate/school/daycareClass/page',
    '/courseClass/updatePublish',
    '/daycareTemplate/school/introduce/daycareClass'
  ];
  return httpUrl;
}

export function goodsUrl() {
  // 订单
  const httpUrl = [];
  return httpUrl;
}
